import { IndicatorYear } from "~/containers/IndicatorYear";
import { LayoutPublic } from "~/containers/Layout";

function StatsAnneePage() {
  return (
    <LayoutPublic>
      <IndicatorYear />
    </LayoutPublic>
  );
}

export default StatsAnneePage;
